import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4aba8691"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml10 p20"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "bold mb25"
}, "运输合同/附件", -1));
const _hoisted_3 = {
  class: "flex_size_1"
};
const _hoisted_4 = {
  class: "mt15"
};
const _hoisted_5 = {
  class: "flex_size_1 ml10"
};
const _hoisted_6 = {
  class: "mt15 text_blue pointer"
};
const _hoisted_7 = {
  class: "flex_size_1 ml10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item mb15 flex_FSBS",
      key: index
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, " 生成时间: " + _toDisplayString($setup.moment($setup.data.list[index].createTime).format("YYYY-MM-DD HH:mm")), 1), _createElementVNode("p", _hoisted_4, "合同类型:" + _toDisplayString($setup.data.list[index].contractName), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, " 合同编号: " + _toDisplayString($setup.data.list[index].contractNo), 1), _createElementVNode("p", _hoisted_6, " 运输单号:" + _toDisplayString($setup.data.list[index].orderNo), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, " 承运人: " + _toDisplayString($setup.isPhoneNumber($setup.data.list[index].driverName) ? $setup.phoneDesc($setup.data.list[index].driverName) : $setup.EncryptName($setup.data.list[index].driverName)), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: () => $setup.toViewContract($setup.data.list[index])
    }, {
      default: _withCtx(() => [_createTextVNode("查看")]),
      _: 2
    }, 1032, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: () => $setup.toDownload($setup.data.list[index])
    }, {
      default: _withCtx(() => [_createTextVNode("下载")]),
      _: 2
    }, 1032, ["onClick"])])]);
  }), 128)), _createVNode(_component_el_pagination, {
    "page-size": $setup.data.size,
    class: "mt20",
    background: "",
    layout: "pager,total",
    total: $setup.data.total,
    onCurrentChange: $setup.currentChange
  }, null, 8, ["page-size", "total", "onCurrentChange"])]), _createVNode(_component_el_dialog, {
    style: {
      "width": "85vw"
    },
    top: "0",
    modelValue: $setup.data.protocolVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.data.protocolVisible = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_image, {
      src: $setup.data.base64Str,
      lazy: ""
    }, {
      error: _withCtx(() => [_createTextVNode("加载中，请稍等... ")]),
      _: 1
    }, 8, ["src"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}